import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Dialog } from "./dialog";
import { NegativeValueDirective } from "./directive/negative-value.directive";

import { FormsModule } from "@angular/forms";
import { KeyboardNumComponent } from "./components/keyboard/numeric/keyboard-num/keyboard-num.component";
import { KeyboardAlphaComponent } from "./components/keyboard/alphanumeric/keyboard-alpha/keyboard-alpha.component";
import { NumbersOnlyDirective } from "./directive/numbers-only.directive";
import { ShowMatKeyboardDirective } from "./directive/show-keyboard.directive";

import { MatInputModule } from "@angular/material/input";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { InputLockDirective } from "./directive/input-lock.directive";
import { ApiImageComponent } from "./helpers/api-image/api-image.component";
import { ImageCheckPipe } from "./pipes/image-check.pipe";
import { ConfigurationComponent } from "app/main/worker/main-window/modals/configuration/configuration.component";
import { TranslateModule } from "@ngx-translate/core";
import { NgSelectDynamicComponent } from "./helpers/ng-select-dynamic/ng-select-dynamic.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { StringFormat } from "./pipes/stringFormat.pipe";
import { MeasureUnitComponent } from './helpers/measure-unit/measure-unit.component';
import { StringToContentPipe } from "./pipes/stringToContent";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    TranslateModule.forChild(),
    NgSelectModule
  ],
  declarations: [
    NegativeValueDirective,
    KeyboardAlphaComponent,
    KeyboardNumComponent,
    NumbersOnlyDirective,
    ShowMatKeyboardDirective,
    InputLockDirective,
    ApiImageComponent,
    ImageCheckPipe,
    StringToContentPipe,
    ConfigurationComponent,
    NgSelectDynamicComponent,
    StringFormat,
    MeasureUnitComponent,
  ],
  exports: [
    NegativeValueDirective,
    KeyboardAlphaComponent,
    KeyboardNumComponent,
    NumbersOnlyDirective,
    ShowMatKeyboardDirective,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    InputLockDirective,
    ApiImageComponent,
    ImageCheckPipe,
    ConfigurationComponent,
    NgSelectDynamicComponent,
    StringFormat,
    MeasureUnitComponent,
    StringToContentPipe
  ],
  providers: [Dialog, ImageCheckPipe],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
